export default __webpack_public_path__ + "static/media/Ww.0303a235.wav";